// Gedeelde onderdelen: wettelijke vereisten, Z-ticket bon, centralisatie-popup, kop
import { useEffect, useState } from "react";
import { api, getal } from "../api";
import KassierMenu from "./KassierMenu";

export function Kop({ titel, sub, onAfmelden }) {
  return (
    <div className="h-[72px] bg-white border-b border-slate-200 flex items-center px-5 gap-3">
      <div className="w-10 h-10 rounded-xl bg-blue-600 text-white font-extrabold flex items-center justify-center text-xl">S</div>
      <div>
        <div className="font-bold text-slate-800 text-lg leading-tight">{titel}</div>
        <div className="text-xs text-slate-500">{sub}</div>
      </div>
      <div className="ml-auto"><KassierMenu onAfmelden={onAfmelden} /></div>
    </div>
  );
}

const VEREISTEN = [
  ["Dagelijkse inschrijving per vestiging", "KB nr. 1, art. 22"],
  ["Dagtotaal per btw-tarief", null],
  ["Verkoop > €500 incl. btw afzonderlijk", "sinds 10/01/2026"],
  ["Na Z-ticket onwijzigbaar + ondertekend", "Circulaire 2020/C/20"],
  ["Correctie enkel via nieuwe inschrijving", null],
  ["Centralisatieboek op de maatschappelijke zetel", null],
  ["Bewaring 10 jaar", "art. 60 Btw-Wetboek"],
];

export function WettelijkeVereisten() {
  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-4">
      <h3 className="font-bold text-slate-800 mb-2">✅ Wettelijke vereisten</h3>
      {VEREISTEN.map(([t, bron]) => (
        <div key={t} className="flex gap-2 py-1.5 border-b border-dashed border-slate-100 text-sm text-slate-800">
          <span className="text-green-600 font-extrabold">✓</span>
          <div>{t}{bron && <div className="text-xs text-slate-500">{bron}</div>}</div>
        </div>
      ))}
    </div>
  );
}

export function ZTicketBon({ z, vestiging }) {
  const r = (l, w, vet) => (
    <div className={`flex justify-between ${vet ? "font-bold" : ""}`}><span>{l}</span><span>{w}</span></div>
  );
  const lijn = <hr className="border-0 border-t border-dashed border-slate-400 my-1.5" />;
  const t = z.afgesloten_op || "";
  const tijd = t ? `${t.slice(8, 10)}/${t.slice(5, 7)}/${t.slice(0, 4)} ${t.slice(11, 16)}` : "";
  const b = z.bedragen_eur || {}, btw = z.btw_eur || {};
  return (
    <div id="z-bon" className="w-[300px] bg-[#fffef9] border border-slate-200 p-5 font-mono text-xs text-slate-900 leading-relaxed shadow">
      <div className="text-center"><b>SINGH EXPRESS SHOP</b><br />{vestiging?.korte_naam?.toUpperCase()}<br />BTW {vestiging?.btw}</div>
      {lijn}
      <div className="text-center"><b>Z-RAPPORT nr. {z.z_nummer}</b><br />{tijd}</div>
      {lijn}
      {r("Aantal tickets", z.aantal_tickets)}
      {lijn}
      {r("Omzet 6%", getal(b["6"]))}
      {r("btw 6%", getal(btw["6"]))}
      {r("Omzet 21%", getal(b["21"]))}
      {r("btw 21%", getal(btw["21"]))}
      {!!b.vrij && r("Vrijgesteld", getal(b.vrij))}
      {!!b.tabak && r("Tabak (bijz. regeling)", getal(b.tabak))}
      {lijn}
      {r("TOTAAL", getal(z.totaal_eur), true)}
      {lijn}
      {r("Cash", getal(z.betaal_eur?.cash))}
      {r("Bancontact", getal(z.betaal_eur?.bancontact))}
      {lijn}
      <div className="text-center text-[10px]">Hash: {z.hash?.slice(0, 4)}…{z.hash?.slice(-4)} ✓ ongewijzigd</div>
    </div>
  );
}

export function CentralisatiePopup({ onSluit }) {
  const [zetel, setZetel] = useState(null);
  useEffect(() => { api.get("/zetel").then((r) => setZetel(r.data)).catch(() => {}); }, []);
  return (
    <div className="fixed inset-0 bg-slate-900/40 z-50 flex items-center justify-center p-4" onClick={onSluit}>
      <div className="bg-white rounded-2xl w-full max-w-lg p-7 text-center shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="w-16 h-16 rounded-2xl bg-blue-50 mx-auto mb-3 flex items-center justify-center text-3xl">🏢</div>
        <h2 className="text-xl font-bold text-slate-800 mb-2">Centralisatieboek</h2>
        <p className="text-sm text-slate-600 leading-relaxed">
          Het centralisatieboek wordt bijgehouden op de <b>maatschappelijke zetel</b>.<br />
          Het is niet raadpleegbaar vanaf de kassa van een winkel.
        </p>
        <div className="bg-slate-50 border border-slate-200 rounded-xl p-4 my-4 text-left text-sm leading-relaxed text-slate-800">
          <b>Maatschappelijke zetel</b><br />
          {zetel?.firmanaam}<br />{zetel?.adres}<br />BTW {zetel?.btw}<br />
          <span className="text-xs text-slate-500">KB nr. 1, art. 22 — centralisatie per btw-tarief per aangifteperiode</span>
        </div>
        <button onClick={onSluit} className="bg-blue-600 text-white font-semibold rounded-xl px-8 py-3">OK, begrepen</button>
      </div>
    </div>
  );
}
